import { module } from './store'
import { createModule } from '@vue-storefront/core/lib/module'

export const KEY = 'vacancies'
export const Vacancies = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module }] }
})
